var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',{class:['atom-textarea', { 'atom-textarea--error': _vm.hasError }],attrs:{"placeholder":_vm.placeholder,"disabled":_vm.disabled,"rows":_vm.rows,"maxlength":_vm.maxlength},domProps:{"value":_vm.value},on:{"input":_vm.handleInput,"blur":_vm.handleBlur,"focus":_vm.handleFocus}})
}
var staticRenderFns = []

export { render, staticRenderFns }